@mixin sqt-button-typed {
	--button-text-color: #{$white-color};
	--button-bg-color: var(--button-color);
	--button-border-color: var(--button-color);
	--button-hover-text-color: #{$white-color};
	--button-hover-bg-color: var(--button-color-light-3, var(--button-color));
	--button-hover-border-color: var(
		--button-color-light-3,
		var(--button-color)
	);
	--button-active-text-color: #{$white-color};
	--button-active-bg-color: var(--button-color-dark-2, var(--button-color));
	--button-active-border-color: var(
		--button-color-dark-2,
		var(--button-color)
	);
	--button-disabled-text-color: #{$white-color};
	--button-disabled-bg-color: var(
		--button-color-light-5,
		var(--button-color)
	);
	--button-disabled-border-color: var(
		--button-color-light-5,
		var(--button-color)
	);
	--button-outline-color: var(--button-color-light-5, var(--button-color));

	&.is-plain {
		--button-text-color: var(--button-color);
		--button-bg-color: var(--button-color-light-9, var(--button-color));
		--button-border-color: var(--button-color-light-5, var(--button-color));
		--button-hover-text-color: #{$white-color};
		--button-hover-bg-color: var(--button-color);
		--button-hover-border-color: var(--button-color);
		--button-active-text-color: #{$white-color};
		--button-active-bg-color: var(
			--button-color-dark-2,
			var(--button-color)
		);
		--button-active-border-color: var(
			--button-color-dark-2,
			var(--button-color)
		);
		--button-disabled-text-color: var(
			--button-color-light-5,
			var(--button-color)
		);
		--button-disabled-bg-color: var(
			--button-color-light-9,
			var(--button-color)
		);
		--button-disabled-border-color: var(
			--button-color-light-8,
			var(--button-color)
		);
	}

	&.is-text {
		--button-text-color: var(--button-color);
		--button-bg-color: transparent;
		--button-border-color: transparent;
		--button-hover-text-color: var(--button-color);
		--button-hover-bg-color: var(
			--button-color-light-9,
			var(--button-color)
		);
		--button-hover-border-color: transparent;
		--button-active-text-color: var(--button-color);
		--button-active-bg-color: var(
			--button-color-light-8,
			var(--button-color)
		);
		--button-active-border-color: transparent;
		--button-disabled-text-color: var(
			--button-color-light-5,
			var(--button-color)
		);
		--button-disabled-bg-color: transparent;
		--button-disabled-border-color: transparent;

		&.is-has-bg {
			--button-bg-color: var(--button-color-light-9, var(--button-color));
			--button-hover-bg-color: var(
				--button-color-light-8,
				var(--button-color)
			);
			--button-active-bg-color: var(
				--button-color-light-7,
				var(--button-color)
			);
		}
	}
}

.#{$namespace}-button {
	--button-border-radius: 4px;
	--button-border-width: 1px;
	--button-font-weight: 500;
	--button-icon-gap: 6px;
	--button-text-color: #{$text-secondary-color};
	--button-bg-color: #{$white-color};
	--button-border-color: #{$border-color};
	--button-hover-text-color: #{color-token(primary)};
	--button-hover-bg-color: #{color-token(primary, light-9)};
	--button-hover-border-color: #{color-token(primary, light-7)};
	--button-active-text-color: var(--button-hover-text-color);
	--button-active-bg-color: var(--button-hover-bg-color);
	--button-active-border-color: #{color-token(primary)};
	--button-disabled-text-color: #{$text-placeholder-color};
	--button-disabled-bg-color: #{$white-color};
	--button-disabled-border-color: #{$border-light-color};
	--button-outline-color: #{color-token(primary, light-5)};

	display: inline-flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	height: $control-height;
	padding-block: 0;
	padding-inline: calc($control-height * 0.45);
	line-height: 1;
	white-space: nowrap;
	color: var(--button-text-color);
	text-align: center;
	outline: none;
	transition: 0.1s;
	font-size: $font-size;
	font-weight: var(--button-font-weight);
	user-select: none;
	vertical-align: middle;
	appearance: none;
	-webkit-appearance: none;
	background-color: var(--button-bg-color);
	border: var(--button-border-width) solid var(--button-border-color);
	border-radius: var(--button-border-radius);
	cursor: pointer;

	& + & {
		margin-left: 12px;
	}

	&:hover:not(.is-disabled) {
		color: var(--button-hover-text-color);
		border-color: var(--button-hover-border-color);
		background-color: var(--button-hover-bg-color);
	}

	&:active:not(.is-disabled) {
		color: var(--button-active-text-color);
		border-color: var(--button-active-border-color);
		background-color: var(--button-active-bg-color);
	}

	&:focus-visible {
		outline: 2px solid var(--button-outline-color);
		outline-offset: 1px;
	}

	&::-moz-focus-inner {
		border: 0;
	}

	&__icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 1em;
		line-height: 1;
		color: inherit;

		.#{$namespace}-svg,
		svg {
			width: 1em;
			height: 1em;
		}

		&.is-loading {
			animation: #{$namespace}-button-rotate 1s linear infinite;
		}

		& + .#{$namespace}-button__text {
			margin-left: var(--button-icon-gap);
		}
	}

	&__text {
		display: inline-flex;
		align-items: center;
	}

	&--large {
		--button-icon-gap: 8px;
		height: calc(#{$control-height} + 8px);
		padding-inline: calc((#{$control-height} + 8px) * 0.45);
		font-size: $font-size;
	}

	&--small {
		--button-icon-gap: 4px;
		height: calc(#{$control-height} - 8px);
		padding-inline: calc((#{$control-height} - 8px) * 0.45);
		font-size: calc(#{$font-size} - 2px);
	}

	&.is-plain {
		--button-hover-text-color: #{color-token(primary)};
		--button-hover-bg-color: #{$white-color};
		--button-hover-border-color: #{color-token(primary)};
		--button-active-text-color: #{color-token(primary)};
		--button-active-bg-color: #{color-token(primary, light-9)};
		--button-active-border-color: #{color-token(primary)};
	}

	// 文字按钮（对齐 Element Plus text）
	&.is-text {
		--button-text-color: #{$text-secondary-color};
		--button-bg-color: transparent;
		--button-border-color: transparent;
		--button-hover-text-color: #{$text-primary-color};
		--button-hover-bg-color: #{alpha-color($black-color, 6%)};
		--button-hover-border-color: transparent;
		--button-active-text-color: #{$text-primary-color};
		--button-active-bg-color: #{alpha-color($black-color, 10%)};
		--button-active-border-color: transparent;
		--button-disabled-text-color: #{$text-disabled-color};
		--button-disabled-bg-color: transparent;
		--button-disabled-border-color: transparent;

		&.is-loading::before {
			background-color: transparent;
		}

		&.is-has-bg {
			--button-bg-color: #{alpha-color($black-color, 6%)};
			--button-hover-bg-color: #{alpha-color($black-color, 10%)};
			--button-active-bg-color: #{alpha-color($black-color, 14%)};
		}
	}

	&.is-round {
		border-radius: calc(#{$control-height} / 2);
	}

	&.is-circle {
		width: $control-height;
		padding-inline: 0;
		border-radius: 50%;

		&.#{$namespace}-button--large {
			width: calc(#{$control-height} + 8px);
		}

		&.#{$namespace}-button--small {
			width: calc(#{$control-height} - 8px);
		}
	}

	&.is-typed {
		@include sqt-button-typed;
	}

	&.is-loading {
		position: relative;
		pointer-events: none;

		&::before {
			content: '';
			position: absolute;
			z-index: 1;
			pointer-events: none;
			inset: -1px;
			border-radius: inherit;
			// 白膜。shade-color 编成 rgba；白被配成 CSS 变量时退回原色
			background-color: shade-color($white-color, 30%);
		}

		.#{$namespace}-button__icon {
			position: relative;
			z-index: 2;
		}
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 1;
	}

	// 只跟 .is-disabled，不跟 :disabled：loading 会设 native disabled，但要保持原色 + 白膜
	&.is-disabled {
		// 底色不改：业务 default 铺了 white-color-3，再写 disabled-bg 会整颗褪成白/灰
		color: var(--button-disabled-text-color);
		cursor: not-allowed;
		border-color: var(--button-disabled-border-color);
		background-image: none;
	}
}

@keyframes #{$namespace}-button-rotate {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
